import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { breadcrumb, content, topNavigation } from './data';
import { environment } from 'src/environments/environment';
import { YoutubeModalComponent } from 'src/app/components/youtube-modal/youtube-modal.component';
import { githubLink } from '../solutions/data';

@Component({
  selector: 'app-sitemule-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SitemuleDownloadComponent {
  topNavigation = topNavigation;
  breadcrumb = breadcrumb;
  allPersons = environment.data.allPersons.filter(
    (person) => person.showInSmallSize
  );
  content = content;
  contacts = environment.data.contacts;
  githubLink = githubLink;
  mail = 'support@sitemule.com';
  mailInfo =
    '?subject=Installation%20of%20Sitemule%20Model%20Studio&body=I%20would%20like%20to%20book%20an%20installation%20session.%0A%0AMy%20contact%20information%20is:%0AName:%0ACompany:%0ACountry:%0APhone:';

  @ViewChild('youtubeRef') youtubeModal!: YoutubeModalComponent;

  showYoutubeModal() {
    if (this.youtubeModal) {
      this.youtubeModal.showVideo();
    }
  }
}
